import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { NewDayTripPlanEditPresenter } from "./presenter";
import { useDayTripPlanEditQuery } from "../../model/repository/new";

type Props = {
	hotelID: string;
	planID: string | undefined;
	activeLangCode: LangCode;
};

export const NewDayTripPlanEditContainer = ({ hotelID, planID, activeLangCode }: Props) => {
	const serverModel = useDayTripPlanEditQuery({ hotelID, planID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })} />;
	}

	return <NewDayTripPlanEditPresenter activeLangCode={activeLangCode} serverModel={serverModel} />;
};

NewDayTripPlanEditContainer.displayName = "NewDayTripPlanEditContainer";
